export const MASKA_MODELU = 'MaskaModelu';

export const PPDRUH = 'PpDruh';
export const PPSERVICENR = 'PpServisniCislo';
export const PPNR = 'PpCislo';
